import { useEffect, useState } from 'react';

import qapi from 'views_shared/app/javascript/api';
import qlog from 'views_shared/app/javascript/scripts/qlog';
import { isPitchOrigin } from 'views_shared/app/javascript/constants/conversationOriginTypes';

// The header's copy of the pitch's proposed sources. Only the global inbox needs this: the
// request page's thread pane already holds the pitch and passes them straight down.
export default function usePitchedEntities(conversation) {
  const originId = isPitchOrigin(conversation?.origin_type) ? conversation.origin_id : null;
  const [entities, setEntities] = useState(null);

  useEffect(() => {
    if (!originId) {
      setEntities(null);
      return undefined;
    }
    let cancelled = false;
    setEntities(null);
    qapi.pitches.getPitchedEntities(originId).then(({ data, error }) => {
      if (cancelled) return;
      if (error) {
        qlog.error("Failed to load the pitch's proposed sources:", error);
        return;
      }
      setEntities(data?.[0]?.pitched_entities || null);
    });
    return () => {
      cancelled = true;
    };
  }, [originId]);

  return entities;
}
